<template>
  <div>
    <div style="max-width:756px;">
      <b-container>
        <b-row>
          <b-col sm class="p-0 pt-1 pb-1 pr-1">
            <b-card no-body header-tag="header">
              <template v-slot:header>
                <b>Weather</b>
              </template>

              <b-container fluid>
                <b-row class="pt-1" style="height: 100px;">
                  <b-col class="text-left">
                    <label for="radio-group-weather" class="control-label">
                      <small>
                        <b>General Conditions</b>
                      </small>
                    </label>

                    <b-form-group>
                      <b-form-radio-group
                        id="radio-group-weather"
                        v-model="data.weather"
                        v-on:change="update"
                        name="weather-general"
                        size="sm"
                      >
                        <div style="float-left">
                          <b-form-radio value="Clear">Clear</b-form-radio>
                          <b-form-radio value="Rain">Rain</b-form-radio>
                        </div>

                        <div style="float-left">
                          <b-form-radio value="Clouds">Cloud</b-form-radio>
                          <b-form-radio value="Snow">Snow</b-form-radio>
                        </div>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>

                  <b-col class="text-left">
                    <label for="temp" class="control-label">
                      <small>
                        <b>Temperature</b>
                      </small>
                    </label>
                    <b-input-group>
                      <b-form-input
                        id="temp"
                        type="number"
                        v-model="data.temperature"
                        v-on:blur="update"
                        style="max-width:65px;text-align:center;font-weight:bold;"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button disabled variant="outline-secondary" size="sm">
                          <b>&#8451;</b>
                        </b-button>
                      </b-input-group-append>

                      <b-button-group>
                        <b-button
                          v-b-modal="projectId+date"
                          @click="closeTooltip"
                          v-b-tooltip.hover
                          title="Current weather conditions..."
                          size="sm"
                          variant="outline-secondary"
                          class="pr-2 pl-2 p-1 ml-2"
                        >
                          <img alt="weather" src="@/assets/images/weather-icon.svg" height="26px" />
                        </b-button>
                      </b-button-group>
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-row class="pl-2 pr-2 pb-2">
                  <b-form-textarea
                    id="textarea"
                    v-model="data.weatherRemarks"
                    v-on:change="update"
                    size="sm"
                    placeholder="Enter weather remarks..."
                    rows="3"
                    max-rows="6"
                    maxlength="300"
                    style="color:darkblue;"
                  ></b-form-textarea>
                </b-row>
              </b-container>
            </b-card>
          </b-col>

          <b-col sm class="p-0 pt-1 pb-1">
            <b-card no-body header-tag="header">
              <template v-slot:header>
                <b>Workforce</b>
              </template>

              <!-- workforce body -->
              <b-container>
                <b-form style="height: 100px;">
                  <b-row style="padding-top:8px;padding-bottom:25px;">
                    <b-col>
                      <label for="Fm" class="control-label">
                        <small>
                          <b>Foreman</b>
                        </small>
                      </label>
                      <b-form-input
                        id="Fm"
                        type="number"
                        min="0"
                        v-model="data.foreman"
                        v-on:blur="update"
                        style="max-width:65px;text-align:center;font-weight:bold;"
                      ></b-form-input>
                    </b-col>
                    <b-col>
                      <label for="Jm" class="control-label">
                        <small>
                          <b>Journeyman</b>
                        </small>
                      </label>
                      <b-form-input
                        id="Jm"
                        type="number"
                        min="0"
                        v-model="data.journeyman"
                        v-on:blur="update"
                        style="max-width:65px;text-align:center;font-weight:bold;"
                      ></b-form-input>
                    </b-col>
                    <b-col>
                      <label for="Ap" class="control-label">
                        <small>
                          <b>Apprentice</b>
                        </small>
                      </label>
                      <b-form-input
                        id="Ap"
                        type="number"
                        min="0"
                        v-model="data.apprentice"
                        v-on:blur="update"
                        style="max-width:65px;text-align:center;font-weight:bold;"
                      ></b-form-input>
                    </b-col>
                    <b-col>
                      <label for="Oth" class="control-label">
                        <small>
                          <b>Other</b>
                        </small>
                      </label>
                      <b-form-input
                        id="Oth"
                        type="number"
                        min="0"
                        v-model="data.other"
                        v-on:blur="update"
                        style="max-width:65px;text-align:center;font-weight:bold;"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-form>

                <b-row class="pl-2 pr-2 pb-2">
                  <b-form-textarea
                    id="textarea"
                    v-model="data.workforceRemarks"
                    v-on:change="update"
                    size="sm"
                    placeholder="Enter workforce remarks..."
                    rows="3"
                    max-rows="6"
                    maxlength="300"
                    style="color:darkblue;"
                  ></b-form-textarea>
                </b-row>
              </b-container>
            </b-card>
          </b-col>
        </b-row>
      </b-container>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block variant="light" size="sm" @click="$emit('photo-view')">
            <span style="float:left;color:darkred;">
              <strong>Photos</strong>
            </span>
            <span style="float:right;">{{ photos }}</span>
          </b-button>
        </b-card-header>
      </b-card>

      <JournalEntries :data="data"></JournalEntries>
    </div>

 

    <div v-if="errored" class="text-center pt-5">
      <p class="text-danger">An error occurred loading data.</p>
      <p>{{ error }}</p>
    </div>

    <!-- The modal weather -->
    <b-modal
      v-bind:id="projectId+date"
      title="Current Weather"
      size="md"
      button-size="sm"
      hide-footer
    >
      <Weather v-bind:projectId="projectId" :date="date" @apply="onApply" @exit="closeModal"></Weather>
    </b-modal>
  </div>
</template>

<script>
import JournalEntries from "@/components/journal/JournalEntries.vue";
import Weather from "@/components/journal/Weather.vue";
export default {
  name: "JournalPage",
  components: {
    JournalEntries,
    Weather
  },
  props:{
    data: Object
  },

  data: function() {
    return {
      state: this.$store.state,
      projectId: this.$route.params.id,
      date: this.$route.params.date,
      isBusy: false,
      errored: false,
      error: ""
    };
  },
  computed: {
    photos: function() {
      if (this.data.photoCount == 0) {
        return "(none)";
      } else {
        if (this.data.photoCount == 1) {
          return "(" + this.data.photoCount + " photo)";
        } else {
          return "(" + this.data.photoCount + " photos)";
        }
      }
    }
  },
  methods: {

    closeTooltip() {
      this.$root.$emit("bv::hide::tooltip"); //force close toolip - seems to be ios display issue
    },

    onApply(weather) {
      this.data.temperature = weather.temp;
      this.data.weather = weather.general;
      var remarks =
        this.data.weatherRemarks.trim() +
        (this.data.weatherRemarks.length > 0 ? "\n" : "") +
        weather.time +
        ": " +
        weather.desc +
        "\n" +
        weather.wind;
      if (remarks.length < 300) {
        this.data.weatherRemarks = remarks;
      }
      this.update();
      this.$bvModal.hide(this.projectId + this.date);
    },

    closeModal() {
      var id = this.projectId + this.date;
      this.$bvModal.hide(id);
    },
  

    update() {
      let jp = Object.assign({}, this.data, {
        journalEntries: undefined,
        layout: undefined
      }); //update base journalpage, don't send unneeded related objects to api

      this.$auth.acquireToken().then(token => {
        this.$http
          .put("api/JournalPage/" + this.data.id, jp, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.errored = false;
            this.error = "";
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
            this.error = error.response.statusText;
          })
          .finally(() => (this.isBusy = false));
      });
    }
  },

  mounted: function() {
    
  },

  activated: function() {}
};
</script>

<style>
</style>